const header = document.getElementById('js-header');
const navWrapper = document.querySelector('.sticky-nav-wrapper');
const stickyMenu = document.querySelector('.sticky-nav');
const toggleButton = document.getElementById('resort-menu-btn');
const scrollButtons = document.querySelectorAll('button.rm-menu-link');

if (stickyMenu) {
  const hasBanner = stickyMenu.classList.contains('with-banner');
  const ABTestIDHeader = sessionStorage.getItem('ABTestIDHeader');

  toggleButton.addEventListener('click', () => {
    stickyMenu.classList.toggle('open');
  });

  const isSticky = stickyMenu.classList.contains('resort-menu--sticky');

  if (isSticky) {
    let headerHeight = 0;

    let screenOffset = 0;

    let stickyNavHeight = 0;

    const setSticky = () => {
      headerHeight = header.clientHeight;
      const stickyPosition = navWrapper.offsetTop;

      screenOffset = stickyPosition - 10;
      stickyNavHeight = hasBanner ? stickyMenu.clientHeight : 0;
    };

    setSticky();

    const stickyNav = _.debounce(() => {
      const heights = [ABTestIDHeader ? 56 : 50, ABTestIDHeader ? 45 : 46];
      const hdrHeight = window.innerWidth >= 768 ? heights[0] : heights[1];
      const hiddenHeaderWrapper = document.querySelector(
        '.hm__wrapper--active--hide'
      );

      if (window.scrollY >= screenOffset - 40) {
        stickyMenu.classList.add('stuck-rm-top');
        if (hiddenHeaderWrapper === null) {
          stickyMenu.style.top = `${hdrHeight}px`;
        } else {
          stickyMenu.style.top = 0;
        }
        navWrapper.style.height = `${stickyNavHeight}px`;
      } else {
        stickyMenu.classList.remove('stuck-rm-top');
        stickyMenu.style.top = 0;
        navWrapper.style.height = 'auto';
      }
    }, 10);

    const scrollHighlights = () => {
      scrollButtons.forEach(btn => {
        const btnClass = btn.dataset.scrollTo;
        const sectionBox = document
          .querySelector(`.${btnClass}`)
          .getBoundingClientRect();

        const sectionTop = sectionBox.top;
        const sectionBottom = sectionBox.bottom;

        const offset =
          window.innerWidth >= 1200
            ? 159
            : window.innerWidth >= 768
            ? 139
            : 103;

        if (sectionTop <= offset && sectionBottom >= offset) {
          btn.closest('.rm-menu-item').classList.add('active');
        } else {
          btn.closest('.rm-menu-item').classList.remove('active');
        }
      });
    };

    window.addEventListener('scroll', () => {
      stickyNav();
      setSticky();
      scrollHighlights();
    });
    window.addEventListener('resize', setSticky);
    document.addEventListener('DOMContentLoaded', stickyNav);
  }
}
